<template lang="pug">
  el-popover(v-model="popShow" trigger="manual" )
    template
      div.content
        el-checkbox-group(v-model="sel" )
          .item(v-for="it in list")
            el-checkbox( :label="it.actionCode" :disabled="!it.allowDelete")
              div {{it.actionName}}
            .left-button
                el-button.del-button(v-if="it.allowDelete" type="text"
                @click="deleteItem(it)"
                  size="small" icon="el-icon-delete")
        .add
          el-button( @click="addHandler" size="mini" ) 新增自定义权限
      .bottom
          el-button( @click="closePop" size="mini" ) 取消
          el-button( @click="confirm" type="primary"  size="mini" ) 确定

    template(#reference )
      span(@click="addClick")
        el-button(class="icon-button ml-20" type="text" size="small" icon="el-icon-circle-plus-outline" )
    el-dialog(v-dialog-drag title="添加自定义操作权限"
      modal-append-to-body append-to-body
      width="300px"
      top='200px'
      :visible.sync="show",
      :close-on-click-modal="false",
      @close="closeHandler")
      template(#default)
        div.dialog-content
          el-form(:model="form" ref='form' :rules='rules' label-width="80px" size="small" )
            el-form-item(label="操作编码" required prop="actionCode" )
              el-input( v-model="form.actionCode" )
            el-form-item(label="操作名称" required prop="actionName" )
              el-input( v-model="form.actionName" )
      template(#footer)
        div
          .right
            el-button( size="small" @click="closeHandler" ) 取消
            el-button(type="primary" size="small" @click="saveHandler" ) 保存
</template>

<script>
import strategyAuthService from '@/CommonDP/service/strategyAuth-service';

export default {
  name: 'OperateAuthMaintain',
  props: {
    resourceId: {
      type: String,
      default: ''
    },
    selectList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      popShow: false,
      sel: [],
      list: [
        {
          actionId: '168389502413307904',
          actionName: '查看',
          actionCode: 'v',
          resourceId: 'system',
          createUserId: 'ab76e4aecb94443881f3d78eeff86bae',
          allowDelete: false
        }
      ],
      show: false,
      form: {
        actionCode: '',
        actionName: '',
        resourceId: ''
      },
      rules: {
        actionCode: [
          { required: true, message: '请输入操作编码', trigger: 'blur' }
        ],
        actionName: [
          { required: true, message: '请输入操作名称', trigger: 'blur' }
        ]
      }
    };
  },
  computed: {},
  watch: {},
  created () {},
  methods: {
    addClick() {
      this.popShow = !this.popShow;
      this.initList();
      this.initSel();
    },
    openPop () {
      this.popShow = true;
      this.initList();
    },
    initSel() {
      this.sel = this.selectList;
    },
    closePop() {
      this.popShow = false;
      this.sel = [];
    },
    // 保存操作码
    async initList () {
      const params = {
        resourceId: this.resourceId,
        isQueryDefault: true
      };
      const res = await strategyAuthService.queryActionByResourceId(params);
      this.list = res.data.map(it => {
        if (!it.allowDelete) {
          this.sel.push(it.actionCode);
        }
        return it;
      });
    },
    addHandler () {
      this.show = true;
    },
    confirm() {
      const sel = this.sel;
      const result = this.list.filter(it => {
        return sel.includes(it.actionCode);
      });
      this.$emit('select', result || []);
      this.closePop();
    },
    closeHandler () {
      this.show = false;
      this.showPop();
    },
    showPop () {
      this.popShow = true;
    },
    deleteItem(it) {
      this.$confirm(`确认要删除${it.actionName}吗`, '删除操作', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async (dialog) => {
        console.log(dialog);
        const data = {
          actionId: it.actionId
        };
        const res = await strategyAuthService.delAction(data);
        this.$success('删除成功');
        this.initList();
      }).catch(err => {
        console.log(err);
      });
    },
    saveHandler () {
      this.showPop();
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          await this.postData();
        } else {
          console.log('校验未通过');
          return false;
        }
      });
    },

    async postData () {
      const params = this.form;
      params.resourceId = this.resourceId;
      const res = await strategyAuthService.addResourceAction(params);
      this.closeHandler();
      this.$success('添加成功');
      this.initList();
    }
  }
};
</script>

<style scoped lang="scss">
.content {
  max-height: 260px;
  margin-bottom: 12px;
  overflow: auto;
  .item{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 160px;
    height: 33px;
  }
    .del-button{
      display: inline;
      color:red;
    }
  .add{
    margin-top: 10px;
  }
}

.bottom {
  border-top: 1px solid #eee;
  text-align: right;
  padding-top: 12px;
}
.icon-button {
  font-size: 20px;
  vertical-align: top;
}
.ml-20 {
  margin-left: 20px;
}
</style>
